import { Link } from '@tanstack/react-router'
import { StatusDot } from '@/components/ui/status-dot'
import { statusLabels } from '@/lib/status'
import { isColleagueViewer } from '@/lib/scope'
import type { Ticket, ViewerRelation } from '@/types/ticket'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

export function TicketRow({
  ticket,
  relation,
  hrefBase = '/tickets',
  asUser,
}: {
  ticket: Ticket
  relation: ViewerRelation
  hrefBase?: string
  asUser?: string
}) {
  const reporterName = ticket.creator?.name ?? null

  return (
    <Link
      to={`${hrefBase}/${ticket._id}` as never}
      search={{ asUser } as never}
      className="group flex items-center gap-3 px-3 py-2.5 text-sm transition-colors hover:bg-muted"
    >
      <StatusDot status={ticket.status} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="truncate text-foreground">{ticket.subject}</span>
          {isColleagueViewer(relation) && (
            <span className="rounded-sm bg-muted px-1.5 py-px text-[10px] text-muted-foreground">
              Colleague&#39;s
            </span>
          )}
        </div>
        {reporterName && (
          <div className="text-xs text-muted-foreground truncate">{reporterName}</div>
        )}
      </div>
      <span className="text-xs text-muted-foreground tabular-nums hidden sm:inline">
        {statusLabels[ticket.status]}
      </span>
      <span className="w-14 text-right text-xs text-muted-foreground tabular-nums">
        {dayjs(ticket.lastMessageAt).fromNow(true)}
      </span>
    </Link>
  )
}
